import {
  type Collection,
  Model,
  ModelAttributes,
  collection,
  model,
  modelConfig,
  reference,
} from "@mixitone/oom";
import { setAccountId } from "./concerns/SetAccountId";
import Account from "./Account";
import AccountUser from "./AccountUser";
import Club from "./Club";
import FundingAppealEmailTemplate from "./FundingAppealEmailTemplate";
import FundingAppealLandingPage from "./FundingAppealLandingPage";
import FundingOutreach from "./FundingOutreach";
import FundingScoutProspect from "./FundingScoutProspect";
import FundingScoutRun from "./FundingScoutRun";
import TournamentSession from "./TournamentSession";
import { Database } from "./database.types";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    created_by_account_user_id: {
      type: "string",
    },
    donation_tiers: {
      type: "json",
      jsonType: null,
    },
    goal_notes: {
      type: "string",
    },
    is_deleted: {
      type: "boolean",
    },
    letter_template: {
      type: "string",
    },
    name: {
      type: "string",
    },
    status: {
      type: "enum",
      enumType: "open" as Database["public"]["Enums"]["funding_appeal_status"],
    },
    target_cents: {
      type: "number",
    },
    tournament_session_id: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {
    email_templates: collection(() => FundingAppealEmailTemplate as any, "funding_appeal_id"),
    landing_pages: collection(() => FundingAppealLandingPage as any, "funding_appeal_id"),
    funding_outreach: collection(() => FundingOutreach as any, "funding_appeal_id"),
    scout_runs: collection(() => FundingScoutRun as any, "funding_appeal_id"),
    scout_prospects: collection(() => FundingScoutProspect as any, "funding_appeal_id"),
  },
  {
    account: reference(() => Account as any, "account_id"),
    club: reference(() => Club as any, "club_id"),
    created_by_account_user: reference(() => AccountUser as any, "created_by_account_user_id"),
    tournament_session: reference(() => TournamentSession as any, "tournament_session_id"),
  },
);

interface FundingAppeal extends ModelAttributes<typeof config> {}

@setAccountId
@model("funding_appeals", config)
class FundingAppeal extends Model<typeof config> {}

export default FundingAppeal;
